import { render } from "./MultiCalendar.vue?vue&type=template&id=b9850474&scoped=true"
import script from "./MultiCalendar.vue?vue&type=script&lang=js"
export * from "./MultiCalendar.vue?vue&type=script&lang=js"

import "./MultiCalendar.vue?vue&type=style&index=0&id=b9850474&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9850474"]])

export default __exports__